module.exports = __webpack_public_path__ + "static/media/magic_button.73e2b395.svg";